"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonTcfVendor = exports.TcfV3VendorList = exports.TcfGvlV3Vendor = exports.TcfGvlV3DataRetention = exports.TcfGvlV3Url = exports.TcfGvlV3DataCategory = exports.TcfGvlV3Purpose = exports.TcfV2VendorList = exports.TcfVendorListVersion = exports.TcfVendor = exports.TcfStack = exports.TcfPurpose = void 0;
const t = __importStar(require("io-ts"));
/**
 * TCF purpose configuration
 */
exports.TcfPurpose = t.type({
    id: t.number,
    name: t.string,
    description: t.string,
    descriptionLegal: t.string,
});
/**
 * TCF stack configuration
 */
exports.TcfStack = t.type({
    id: t.number,
    purposes: t.array(t.number),
    specialFeatures: t.array(t.number),
    name: t.string,
    description: t.string,
});
/**
 * TCF stack configuration
 */
exports.TcfVendor = t.intersection([
    t.type({
        id: t.number,
        name: t.string,
        purposes: t.array(t.number),
        legIntPurposes: t.array(t.number),
        flexiblePurposes: t.array(t.number),
        specialPurposes: t.array(t.number),
        features: t.array(t.number),
        specialFeatures: t.array(t.number),
        policyUrl: t.string,
        cookieMaxAgeSeconds: t.union([t.number, t.null]),
        usesCookies: t.boolean,
    }),
    t.partial({
        deletedDate: t.string,
        overflow: t.type({
            httpGetLimit: t.number,
        }),
        cookieRefresh: t.boolean,
        usesNonCookieAccess: t.boolean,
        deviceStorageDisclosureUrl: t.string,
    }),
]);
exports.TcfVendorListVersion = t.type({
    gvlSpecificationVersion: t.number,
    vendorListVersion: t.number, // incremented with each published file change
    tcfPolicyVersion: t.number,
    lastUpdated: t.string,
});
/**
 * TCF global vendor list version 2
 */
exports.TcfV2VendorList = t.intersection([
    exports.TcfVendorListVersion,
    t.type({
        purposes: t.record(t.string, exports.TcfPurpose),
        specialPurposes: t.record(t.string, exports.TcfPurpose),
        features: t.record(t.string, exports.TcfPurpose),
        specialFeatures: t.record(t.string, exports.TcfPurpose),
        stacks: t.record(t.string, exports.TcfStack),
        vendors: t.record(t.string, exports.TcfVendor),
    }),
]);
/**
 * TCF GVL v3 purpose configuration (TCF features share the same type)
 */
exports.TcfGvlV3Purpose = t.type({
    id: t.number,
    name: t.string,
    description: t.string,
    illustrations: t.array(t.string),
});
/**
 * TCF GVL v3 data categories configuration
 */
exports.TcfGvlV3DataCategory = t.type({
    id: t.number,
    name: t.string,
    description: t.string,
});
/**
 * TCF GVL v3 URL configuration
 */
exports.TcfGvlV3Url = t.intersection([
    t.type({ langId: t.string, privacy: t.string }),
    t.partial({
        legIntClaim: t.string,
    }),
]);
/**
 * TCF GVL v3 data retention configuration
 */
exports.TcfGvlV3DataRetention = t.intersection([
    t.type({
        purposes: t.record(t.string, t.number),
        specialPurposes: t.record(t.string, t.number),
    }),
    t.partial({
        stdRetention: t.union([t.number, t.null]),
    }),
]);
/**
 * TCF GVL v3 vendor configuration
 */
exports.TcfGvlV3Vendor = t.intersection([
    t.type({
        id: t.number,
        name: t.string,
        purposes: t.array(t.number),
        legIntPurposes: t.array(t.number),
        flexiblePurposes: t.array(t.number),
        specialPurposes: t.array(t.number),
        features: t.array(t.number),
        specialFeatures: t.array(t.number),
        cookieMaxAgeSeconds: t.union([t.number, t.null]),
        usesCookies: t.boolean,
        cookieRefresh: t.boolean,
        usesNonCookieAccess: t.boolean,
        dataRetention: exports.TcfGvlV3DataRetention,
        urls: t.array(exports.TcfGvlV3Url),
        deviceStorageDisclosureUrl: t.string,
    }),
    t.partial({
        deletedDate: t.string,
        overflow: t.type({
            httpGetLimit: t.number,
        }),
        dataDeclaration: t.array(t.number),
    }),
]);
/**
 * TCF global vendor list version 3
 */
exports.TcfV3VendorList = t.intersection([
    exports.TcfVendorListVersion,
    t.type({
        purposes: t.record(t.string, exports.TcfGvlV3Purpose),
        specialPurposes: t.record(t.string, exports.TcfGvlV3Purpose),
        features: t.record(t.string, exports.TcfGvlV3Purpose),
        specialFeatures: t.record(t.string, exports.TcfGvlV3Purpose),
        stacks: t.record(t.string, exports.TcfStack),
        dataCategories: t.record(t.string, exports.TcfGvlV3DataCategory),
        vendors: t.record(t.string, exports.TcfGvlV3Vendor),
    }),
]);
exports.NonTcfVendor = t.intersection([
    t.type({
        /** The vendor name */
        name: t.string,
        /** The transcend purposes associated with each vendor */
        purposes: t.array(t.string),
    }),
    t.partial({
        /** The vendor description */
        description: t.string,
    }),
]);
//# sourceMappingURL=iab.js.map